// Canonical GET urls for the two PRF detail pages.
//
// After submitting or reopening a PRF the page has to be re-rendered from the database. Doing
// that with window.location.reload() re-sends whatever request rendered the page, so on a page
// rendered from an approve POST it replayed the approval and the approvals reappeared straight
// after being removed. Navigating to an explicit GET url cannot replay anything.
//
// The id goes in the query string to match the links the grid and the notification emails use.

const detailUrl = (page, id) => `/Sales/PursuitRequestForm/${page}?id=${encodeURIComponent(id)}`;

export const constructionUrl = (id) => detailUrl('Construction', id);

export const maintenanceUrl = (id) => detailUrl('Maintenance', id);
